<div class="order-card desktop-view">
  <div class="order-col order-info">
    <div class="d-flex align-items-center gap-1">
      <span *ngIf="isChildOrder" class="child-order-number d-flex justify-content-center align-items-center">{{orderNumber}}</span>
      <a [routerLink]="['/account/my-order', order.orderId]" class="order-id"
        (click)="gotoDetail(order)">{{ order.orderId }}</a>
    </div>
    <div class="order-text">{{ order.orderDate | date : "HH:mm dd/MM/yyyy" }}</div>
  </div>

  <div class="order-col order-price">
    <div class="fw-bold">{{ order.finalPrice | currencySymbol }}</div>
    <div [innerHTML]="getTotalItems(order.items)" class="order-text"></div>
    <!-- <div *ngIf="order.appliedVoucher" class="d-flex gap-1 align-items-center">
      <img src="assets/svg/coupon-1.svg" style="max-width: 17px" loading="lazy" />
      <span style="color: var(--theme-color)">
        <h6>{{ order.appliedVoucher.code }}</h6>
      </span>
    </div>
    <div *ngIf="(order.appliedVouchers?.length ?? 0) > 0" class="d-flex gap-1 align-items-center">
      <div *ngFor="let voucher of order.appliedVouchers">
        <img src="assets/svg/coupon-1.svg" style="max-width: 17px" loading="lazy" />
        <span style="color: var(--theme-color)">
          <h6>{{ voucher.code }}</h6>
        </span>
      </div>
    </div>
    <div *ngIf="order.giftItems && order.giftItems.length > 0">
      <img src="assets/svg/gift/gift.svg" loading="lazy" />
    </div> -->
  </div>

  <div class="order-col order-status">
    <ng-container *ngIf="order.displayStatus">
      <div class="d-flex align-items-center gap-2">
        <div class="icon {{ order.displayStatus.icon }}"></div>
        {{ order.displayStatus.value }}
      </div>
    </ng-container>
    <div *ngIf="order.orderShipping?.[0]?.estimatedDeliveryTime as eta" class="order-text">
      Dự kiến giao {{ eta }}
    </div>
  </div>

  <div class="order-col order-invoice">
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </div>
</div>

<div class="order-card-mobile">
  <div class="mobile-head">
    <a [routerLink]="['/account/my-order', order.orderId]" class="theme-color fw-bold"
      (click)="gotoDetail(order)">{{ order.orderId }}</a>
    <ng-container *ngIf="getOrderStatus(order.orderStatus) as status">
      <div class="d-flex align-items-center gap-2">
        <div class="icon {{ status.icon }}"></div>
        {{ status.value }}
      </div>
    </ng-container>
  </div>
  <div class="mobile-row">
    <span class="mobile-label">Ngày tạo đơn</span>
    <span>{{ order.orderDate | date : "HH:mm:ss dd/MM/yyyy" }}</span>
  </div>
  <div class="mobile-row">
    <span class="mobile-label">Số lượng sản phẩm</span>
    <span>{{ totalQuantity }}</span>
  </div>
  <div class="mobile-row">
    <span class="mobile-label">Giá trị đơn hàng</span>
    <span class="mobile-price">{{ order.finalPrice | currencySymbol }}</span>
  </div>
  <div class="mobile-row" *ngIf="order.orderShipping?.[0]?.estimatedDeliveryTime as eta">
    <span class="mobile-label">Dự kiến giao</span>
    <span>{{ eta }}</span>
  </div>
  <div class="mobile-actions">
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </div>
</div>

<ng-template #actions>
  <button *ngIf="canReOrder" type="button" class="reorder-btn" (click)="reOrder()" [disabled]="isReordering"
    data-cta="order.reorder" data-cta-loc="orders">
    Đặt lại đơn
  </button>
  <div class="invoice-dropdown">
    <span class="invoice-trigger">
      Giấy tờ ({{ order.invoices?.length ?? 0 }})
      <i class="ri-arrow-down-s-line"></i>
    </span>
    <div class="invoice-menu" *ngIf="order.invoices && order.invoices.length > 0">
      <div *ngFor="let inv of order.invoices; let idx = index">
        <a href="javascript:void(0)" (click)="getOrderInvoice(order, inv.invoiceCode)" data-cta="order.invoice"
          data-cta-loc="orders" [class.disabled]="isGettingInvoice[inv.invoiceCode]" rel="noopener noreferrer">
          <span class="d-flex align-items-center gap-2">
            <i class="ri-eye-line"></i>
            <span>Hóa đơn {{ idx + 1 }}</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</ng-template>
